export const findById =
  <T extends { id: Id }>(entities?: Array<T>) =>
  (entityId?: Id | null) =>
    entities?.find(({ id }) => id === entityId)
